module.exports = __webpack_public_path__ + "static/f1-91cd6bdaae10699d21c9eb6a9defaa69.png";